export default class DeviceDetector {
    constructor() {
        this.detectWindowWidth();
    }

    detectWindowWidth() {
        this.windowWidth = window.innerWidth;
    }

    checkScreenBreakpoint(breakpoint) {
        if (!DeviceDetector.breakpoints.hasOwnProperty(breakpoint)) {
            return false;
        }
        if (DeviceDetector.breakpoints[breakpoint] > this.windowWidth) {
            return true;
        }
        return false;
    }

    getCurrentBreakpoint() {
        for (let breakpoint of Object.keys(DeviceDetector.breakpoints)) {
            if (DeviceDetector.breakpoints[breakpoint] > this.windowWidth) {
                return breakpoint;
            }
        }
        return Object.keys(DeviceDetector.breakpoints).at(-1);
    }

    isCurrentBreakpointLowerThan(comparedBreakpoint) {
        if (!DeviceDetector.breakpoints.hasOwnProperty(comparedBreakpoint)) {
            throw new Error('Breakpoint not found');
        }
        const currentBreakpoint = this.getCurrentBreakpoint();
        const breakpoints = Object.keys(DeviceDetector.breakpoints).reverse();
        for (let breakpoint of breakpoints) {
            if (breakpoint == comparedBreakpoint) {
                return true;
            } else if (breakpoint == currentBreakpoint) {
                return false;
            }
        }
    }
}

DeviceDetector.breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
